module.exports = __webpack_public_path__ + "static/media/Pic-0298.31188ff7.jpg";